import ApiHelper from "../../../Helpers/ApiHelper";

export { CONTRACTS_PENDING_EVENT } from "../../../Helpers/ContractsPendingSignal";

// Must match ContractAudienceEnum on the backend.
export const ContractAudience = {
  CompanyAdmin: 1, // written by Cus-Pro, accepted by the company's admins
  Candidate: 2, // written by the company, accepted by its candidates
};

// Promise wrapper around ApiHelper's callback style. Resolves (never rejects) with
// { ok, status, data, message } so callers can show the server's message on 400/403.
const call = (method, url, payload, token) =>
  new Promise((resolve) => {
    const done = (res) =>
      resolve({
        ok: res?.status >= 200 && res?.status < 300 && res?.data?.statusCode === 1,
        status: res?.status ?? 0,
        data: res?.data?.data,
        message: res?.data?.message,
      });
    if (method === "get") ApiHelper.getAsync(url, payload, done, token);
    else ApiHelper.postAsync(url, payload, done, token);
  });

export const contractApi = {
  list: (token, companyId, audience) => call("get", "Contract/GetCompanyContracts", { companyId, audience }, token),
  upsert: (token, dto) => call("post", "Contract/UpsertContract", dto, token),
  remove: (token, id) => call("post", "Contract/DeleteContract", { id }, token),
  log: (token, contractId) => call("get", "Contract/GetContractLog", { contractId }, token),
  pending: (token) => call("get", "Contract/GetMyPendingContracts", null, token),
  accept: (token, contractVersionIds) => call("post", "Contract/AcceptContracts", { contractVersionIds }, token),
};
